import React from "react";
import HeroImage from "../../assets/images/family.png";
import HeroImageSmall from "../../assets/images/family_low.webp";
import { useBlurredImageLoader } from "../../utils/useBlurredImageLoader";

const HeroSection = () => {
  const { containerRefs, imgRefs } = useBlurredImageLoader(2);
  const [mobileContainerRef, desktopContainerRef] = containerRefs;
  const [mobileImgRef, desktopImgRef] = imgRefs;

  return (
    <>
      {/* Mobile View: Text then Image */}
      <div className="block sm:hidden px-10 py-10 font-poppins text-green">
        <div className="mb-8 ">
          <h1 className="text-[28px] font-bold leading-tight mb-6">
            Life At Roselea
          </h1>
          <p className="text-[12px] leading-relaxed">
            At Roselea Care Homes, life is about more than just care it's a warm
            and nurturing environment...
          </p>
        </div>
        <div 
          ref={mobileContainerRef}
          className="blurred-img w-full rounded-xl overflow-hidden"
          style={{ backgroundImage: `url(${HeroImageSmall})` }}
        >
          <img
            ref={mobileImgRef}
            src={HeroImage}
            alt="Hero"
            className="w-full rounded-xl object-cover"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />
        </div>
      </div>

      {/* Tablet and Larger View: Background Image with Overlay */}
      <div className="hidden sm:block relative w-full min-h-[500px] sm:min-h-[600px] lg:min-h-[700px] z-10 overflow-hidden mb-[100px]">
        {/* Background Image with Blur Effect */}
        <div 
          ref={desktopContainerRef}
          className="blurred-img absolute inset-0 w-full h-full"
          style={{ backgroundImage: `url(${HeroImageSmall})` }}
        >
          <img
            ref={desktopImgRef}
            src={HeroImage}
            alt="Hero"
            className="w-full h-full object-cover object-center sm:object-fit"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />
        </div>
        <div className="absolute inset-0 z-10 bg-gradient-to-r from-white to-transparent"></div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-20 px-10  py-16 md:py-24 lg:py-32 max-w-7xl mx-auto flex flex-col items-start justify-center font-poppins text-green">
          <div className="max-w-full sm:max-w-xl lg:max-w-2xl">
            <h1 className="text-4xl lg:text-[42px] xl:text-[70px] font-bold leading-tight mb-8">
              Life At Roselea
            </h1>
            <p className="text-lg lg:text-xl xl:text-2xl leading-relaxed">
              At Roselea Care Homes, life is about more than just care it's a
              warm and nurturing environment...
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
